import {
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  Grid,
  Link,
  makeStyles,
  Typography,
  List,
  ListItem,
  CircularProgress,
} from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useHistory } from "react-router-dom";
import HomeHeaderMenu from "../Home/HomeHeaderMenu";
import SettingsIcon from "@material-ui/icons/Settings";
import CustomSelect from "../../Components/CustomSelect";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Bar, Pie, Line, Doughnut } from "react-chartjs-2";
import GaugeChart from "react-gauge-chart";
import html2canvas from "html2canvas";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CustomSelectMulti from "../../Components/CustomSelectMulti";
import { useLocation } from "react-router";
import DataService from "../../Service";
import chartConstants from "../../Pages/Roles/Organization/ManageInfo/Dashboard/ChartConstants";
import DashboardChartService from "../Roles/Organization/ManageInfo/Dashboard/DashboardChartService";
import AssignmentsByGraph from "../Roles/Organization/ManageInfo/Dashboard/AssignmentGraphs/AssignmentByGraph";
import SLAMetricsGraph from "../Roles/Organization/ManageInfo/Dashboard/AssignmentGraphs/SLAMetricsGraph";
import EvaluationRatingsGraph from "../Roles/Organization/ManageInfo/Dashboard/AssignmentGraphs/EvaluationRatingsGraph";
import AssignmentStatusGraph from "../Roles/Organization/ManageInfo/Dashboard/AssignmentGraphs/AssignmentStatusGraph";
import { SaveAlt } from "@material-ui/icons";
import jsPDF from "jspdf";
import moment from "moment";
import logoImage from "../../Images/acuity-logo.png";
import clientLogoDemo from "../../Images/demo_client_new_logo.png";
import { useSelector } from "react-redux"
const barOptions = {
  plugins: {
    legend: {
      align: "center",
      labels: {
        boxWidth: 25,
        padding: 15,
      },
    },
  },
  scales: {
    y: {
      //   max: 24,
      min: 0,
      ticks: {
        stepSize: 1,
      },
      grace: "50%",
    },
  },
};
const graphBrandingColors = {
  evaluationRatings: "#6ABC91",
  objectivesByLeadership: "#40BAC6",
  mostUtilizedCoaches: "#3969A5",
  assignmentsPerMonth: ["#078F47", "#40BAC6", "#B5B440", "#086e99", "#A1A2A5"],
  assignmentBy: "#398BAD",
};
// const graphBrandingColors = {
//   evaluationRatings:"#007D82",
//   objectivesByLeadership:"#40BAC6",
//   mostUtilizedCoaches:"#07438f",
//   assignmentsPerMonth:["#078f47", "#07438f","#a3a110", "#40bac6","#086e99","#636569"],
//   assignmentBy:"#078F47"
// }
const useStyles = makeStyles((theme) => ({
  small: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    margin: "0 auto",
  },
}));
let first = true;
function Dashboard() {
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
  });

  const [mostUtilizedLocationArr, setMostUtilizedLocationArr] = useState([]);

  const getLocationArr = (orgId: any) => {
    DataService.getData(
      { organisation_id: orgId || undefined },
      "mostUtilizedLocation"
    )
      .then((response) => {
        const filter = response?.location_filter.map((el: any) => {
          return el.value;
        });
        setMostUtilizedLocationArr(filter);
      })
      .catch((err) => {});
  };
  const [newOpen, setNewOpen] = useState(false);
  const history = useHistory();
  const classes = useStyles();
  const [userData, setUserData] = useState({
    serviceType: "Last 6 months",
    assignmentDuration: "Last 6 months",
    client: "",
    assignmentPerMonthDuration: "",
    perMonthDatatimePeriod: { byTime: "Last 6 months", byType: "by service" },
    avgDurationPeriod: "Last 6 months",
    assignmentMostUtilizeCoach: "",
    mostUtilizedLocation: "",
  });
  const [newChecked, setNewChecked] = useState({});
  const [orgListsArr, setOrgListsArr] = useState([]);
  const [org_attribute, setOrg_attribute] = useState([]);
  const [assignmentDurationData, setAssignmentDurationData] = useState(
    chartConstants.linedata
  );
  let constants: any = {
    labels: [],
    datasets: [
      {
        label: "Number of clients",
        maxBarThickness: 40,
        data: [],
        backgroundColor: [
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
        ],
        borderColor: [
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
        ],
        borderWidth: 1,
      },
    ],
  };
  const [assignmentStatusChartData, setAssignmentStatusChartData] = useState({
    ...constants,
  });
  const [currentNewChartDataArr, setCurrentNewChartDataArr] = useState([]);
  const [currentChartDataArr, setCurrentChartDataArr] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [checked, setChecked] = useState({});
  const [slaMatrixPercentage, setSlaMatrixPercentage] = useState(0);
  const [assignmentUtilizeCoach, setAssignmentUtilizeCoach] = useState(
    chartConstants.data
  );
  const [assignmentCompetency, setAssignmentCompetency] = useState({
    ...constants,
  });
  const [assignmentCountData, setAssignmentCountData] =
    useState<any>(undefined);
const globalUserData = useSelector((state: any) => state.commonReducer);
  
  const orgId: any = globalUserData?.organisation_id;
  const { pathname } = useLocation();
  const [serviceList, setServiceList] = useState([]);
  const fetchService = () => {
    DataService.getData({}, "fetch_service")
      .then((res) => {
        if (res?.success) {
          setServiceList(res["services"]);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getLocationArr(orgId);
    getAssignmentDurationWiseGraph(userData.assignmentDuration);
    getAssignmentStatusGraph();
    getAssignmentMonthWiseCountGraph(userData.perMonthDatatimePeriod);
    getAssignmentBySla();
    getAssignmentUtilizeCoach(userData.assignmentMostUtilizeCoach);
    getAssignmentCompetency();
    getAssignmentCount();
    fetchService();
    // getEvaluationRating(orgId,null);
    return () => {
      first = true;
    };
  }, []);

  const onChangeItem = (selectedItemValue: any) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
    if (selectedItemValue.id == "avgDurationPeriod") {
      getAssignmentDurationWiseGraph(selectedItemValue.value);
    }
    if (selectedItemValue.id === "mostUtilizedLocation") {
      getAssignmentUtilizeCoach(selectedItemValue.value);
    }
    if (selectedItemValue.id === "perMonthDatatimePeriod") {
      const forFilter = userData.perMonthDatatimePeriod.byTime;
      const forSubfilter = userData.perMonthDatatimePeriod.byType;

      const newUserPerMonthData = { ...userData };
      let reqArray: any = [];
      if (selectedItemValue.dataIndex === 0) {
        reqArray = [
          { byTimeValue: selectedItemValue.value },
          { byTypeValue: forSubfilter },
        ];
      }
      if (selectedItemValue.dataIndex === 1) {
        reqArray = [
          { byTimeValue: forFilter },
          { byTypeValue: selectedItemValue.value },
        ];
      }
      newUserPerMonthData.perMonthDatatimePeriod.byTime =
        reqArray[0].byTimeValue;
      newUserPerMonthData.perMonthDatatimePeriod.byType =
        reqArray[1].byTypeValue;

      setUserData(newUserPerMonthData);

      getAssignmentMonthWiseCountGraph(
        newUserPerMonthData.perMonthDatatimePeriod
      );
    }
    // if (selectedItemValue.id == "perMonthDatatimePeriod") {
    //   getAssignmentMonthWiseCountGraph(selectedItemValue.value);
    // }
    if (selectedItemValue.id === "assignmentMostUtilizeCoach") {
      getAssignmentUtilizeCoach(selectedItemValue.value);
    }
    if (selectedItemValue.id === "serviceType") {
      getAssignmentCount(selectedItemValue.value);
    }
  };
  const onChangeMultiItem = (obj: any, inputId: any, routeFrom: any) => {

    if (inputId == "org_attributes") {
      org_attribute.length = 0;
      setOrg_attribute(org_attribute.concat(obj));
    }
  };

  const [assignmentPerMonthData, setAssignmentPerMonthData] = useState({
    labels: [],
    datasets: [
      {
        label: "Assignments Per Month",
        data: [],
        backgroundColor: [
          "#3B86FF",
          "#3B86FF",
          "#3B86FF",
          "#3B86FF",
          "#3B86FF",
          "#3B86FF",
        ],
        borderColor: [
          "#3B86FF",
          "#3B86FF",
          "#3B86FF",
          "#3B86FF",
          "#3B86FF",
          "#3B86FF",
        ],
        borderWidth: 1,
      },
    ],
  });

  const fetchGraphData = (params: object, section: string) => {
    return DataService.getData({ ...params, organisation_id: orgId }, section)
      .then((res) => res)
      .catch((err) => err);
  };

  const getAssignmentDurationWiseGraph = (value: any) => {
    DataService.getDirectData(
      "dashboards/monthwise_assignment_duration_graph?organisation_id=" +
        orgId +
        "&filter=" +
        value,
      {}
    ).then((response) => {
      assignmentDurationData.datasets[0].label = "Average duration";
      assignmentDurationData.datasets[0].data = response.data.map(
        (data: any) => data.value
      );
      assignmentDurationData.labels = response.data.map(
        (data: any) => data.key
      );
      setAssignmentDurationData({
        ...setAssignmentDurationData,
        ...assignmentDurationData,
      });
    });
  };
  const getAssignmentStatusGraph = () => {
    var pdata = "?type=organisation&organisation_id=" + orgId;
    DataService.getDirectData("assignments/statistics" + pdata, {}).then(
      (response) => {
        const responseData = response.statistics
          .filter((el: any) => el.label !== "All")
          .map((el: any) => el.value);
        const responseLabels = response.statistics
          .filter((el: any) => el.label !== "All")
          .map((el: any) => el.label);
        setAssignmentStatusChartData((prev: any) => {
          const newData: any = { ...prev };
          newData.datasets[0].label = "Number of assignments";
          newData.datasets[0].data = [...responseData];
          newData.labels = [...responseLabels];
          return newData;
        });
        var localArr: any = [];
        var checkedData: any = {};
        responseLabels.map((option: any, i: any) => {
          var pdata: any = {};
          pdata["checked"] = true;
          pdata["name"] = option;
          pdata["value"] = responseData[i];
          checkedData[option] = true;
          localArr.push(pdata);
        });
        setChecked({ ...checked, ...checkedData });
        setCurrentChartDataArr(localArr);
      }
    );
  };

  const getAssignmentMonthWiseCountGraph = (value: any) => {
    DataService.getDirectData(
      "dashboards/monthwise_assignment_count_graph?organisation_id=" + orgId,
      {
        filter: value.byType ? value.byTime : undefined,
        sub_filter: value.byType ? value.byType : undefined,
      }
    )
      .then((response) => {
        const responseArray = [response.data];
        const updatedAssignmentPerMonthData: any = {
          ...assignmentPerMonthData,
        };
        const DataArray = responseArray
          .map((data) => Object.values(data))
          ?.flatMap((el) => el);
        // updatedAssignmentPerMonthData.datasets[0].label = "Assignments Per Month";
        updatedAssignmentPerMonthData.labels = responseArray
          .map((data) => Object.keys(data))
          ?.flatMap((el) => el);
        const obj: any = {};
        const dataSet = DataArray.map((el: any) => {
          for (let i in el) {
            if (obj[i]) {
              obj[i] = [...obj[i], el[i]];
            } else {
              obj[i] = [el[i]];
            }
          }
        });
        // const backgroundColor = [
        //   "#07438f",
        //   "#078f47",
        //   "#a3a110",
        //   "#40bac6",
        //   "#086e99",
        //   "#636569",
        // ];
        const backgroundColor = graphBrandingColors.assignmentsPerMonth;
        updatedAssignmentPerMonthData.datasets = Object.entries(obj)
          ?.filter((el) => el[0] !== "Not applicable")
          .map((el, ind) => {
            return {
              label: el[0],
              data: el[1],
              backgroundColor: backgroundColor[ind % 6],
            };
          });
        setAssignmentPerMonthData(updatedAssignmentPerMonthData);
        // setChartLoader((prev) => ({ ...prev, assignmentPerMonthData: false }));
      })
      .catch((err) => {
      });
  };
  const [mostUtilizedCoach, setMostUtilizedCoach] = useState([
    { id: 1, name: "India", value: "India" },
    { id: 2, name: "UK", value: "UK" },
    { id: 3, name: "NewZealand", value: "NewZealand" },
  ]);
  const getAssignmentUtilizeCoach = (assignmentMostUtilizeCoach: any) => {
    // var pdata =
    //   orgId == null
    //     ? "?location_filter[]=" + assignmentMostUtilizeCoach
    //     : "?organisation_id=" +
    //       orgId +
    //       "&location_filter[]=" +
    //       assignmentMostUtilizeCoach;

    const params = {
      organisation_id: orgId || undefined,
      location_filter: assignmentMostUtilizeCoach || undefined,
    };
    DataService.getDirectData(
      "dashboards/most_utilised_coaches_graph",
      params
    ).then((response: any) => {
      // if (response.data.length > 0) {
      //   // setAssignmentUtilizeCoach.datasets[0].label = "# of Votes";
      //   // setAssignmentUtilizeCoach.datasets[0].data = response.data.map((data) => data.value);
      //   // setAssignmentUtilizeCoach.labels = response.data.map((data) => data.key);;
      //   // setAssignmentUtilizeCoach({ ...setAssignmentUtilizeCoach, ...assignmentUtilizeCoach });

      // }

      if (response.data.length > 0) {
        const backgroundColor = [
          "#07438f",
          "#078f47",
          "#a3a110",
          "#40bac6",
          "#086e99",
          "#636569",
        ];
        const sortedResponseNames = response.data
          .map((el: any) => el.coach_name)
          .sort();
        const sortedData =
          sortedResponseNames?.map((el: any) => {
            return response.data.find((ell: any) => ell.coach_name === el);
          }) || response.data;
        const updatedMostUtilizeCoach = { ...assignmentUtilizeCoach };
        //   const newDataSet:any = [];
        //   const dataArray:any=[];
        //   //@ts-ignore
        //   const locationSet:any = [...new Set<any>(response.data.map((el:any)=>el.locations).flatMap((el:any)=>el))];
        //   const locationArray =
        //   locationSet.length>0
        //   ? locationSet
        //   //@ts-ignore
        //       : assignmentUtilizeCoach.map((e:any) => e.value);
        //   // const locationArray = ["India", "New zealand"]
        //  const dropDown = locationSet.map((el:any,ind:any)=>{
        //   return {
        //     id:ind+1,name:el,value:el
        //   }
        //  })
        //  if(first){
        //   console.log(dropDown,"dropdown")
        //      setMostUtilizedCoach(dropDown);
        //      first=false;
        //    }
        //   locationArray.map((e:any, index:any) => (newDataSet[index] = { label: e }));
        //   newDataSet.map(
        //     (e:any, index:any) =>
        //       (e.backgroundColor = backgroundColor[index < 6 ? index : index - 6])
        //   );
        //   response.data.forEach((el:any)=>{
        //     const finalData = new Array(locationSet.length).fill(0);
        //     if(el.count.length>0 && el.locations.length>0){
        //       if(el.count?.length === el.locations?.length){
        //         for(let i=0;i<el.count.length;i++){
        //           finalData[locationSet.indexOf(el.locations[i])]=el.count[i]
        //         }

        //       }
        //     }
        //     dataArray.push(finalData) ;
        //   })
        //   newDataSet.map((e:any, index:any) => (e.data = dataArray.map((e:any) => e[index])));
        updatedMostUtilizeCoach.datasets[0].data = sortedData?.map(
          (data: any) => data.count
        );
        updatedMostUtilizeCoach.labels = sortedData?.map(
          (data: any) => data.coach_name
        );
        updatedMostUtilizeCoach.datasets[0].backgroundColor = [
          graphBrandingColors.mostUtilizedCoaches,
        ];
        setAssignmentUtilizeCoach(updatedMostUtilizeCoach);
        let localArr: any = [];
        let checkedData: any = {};
        const labelsArray =
          updatedMostUtilizeCoach.labels || assignmentUtilizeCoach.labels;
        labelsArray?.map((option, i) => {
          let pdata: any = {};
          pdata["checked"] = true;
          pdata["name"] = option;
          pdata["value"] = updatedMostUtilizeCoach.datasets[0]?.data[i];
          checkedData[option] = true;
          localArr.push(pdata);
        });
        setNewChecked({ ...newChecked, ...checkedData });
        setCurrentNewChartDataArr(localArr);
      } else {
        setAssignmentUtilizeCoach((prev: any) => {
          const updatedGraph = { ...prev };
          updatedGraph.datasets[0].data = [];
          updatedGraph.labels = [];
          return updatedGraph;
        });
        setNewChecked({});
        setCurrentNewChartDataArr([]);
      }
    });
  };

  const getAssignmentBySla = () => {
    DataService.getDirectData(
      "dashboards/sla_matrix?organisation_id=" + orgId,
      {}
    ).then((response) => {
      setSlaMatrixPercentage(response.sla_matrix); // assignmentPieDurationData.datasets[0].data = response.data.map((data) => data.value);
    });
  };
  const getAssignmentCompetency = () => {
    var pdata = "?organisation_id=" + orgId;
    DataService.getDirectData("dashboards/competency_graph" + pdata, {}).then(
      (response) => {
        setAssignmentCompetency((prev: any) => {
          const updated = { ...prev };
          updated.datasets[0].label = "Number of assignments";
          updated.datasets[0].data = response.competency_graph.map(
            (data: any) => data.count
          );
          updated.labels = response.competency_graph.map(
            (data: any) => data.competency
          );
          updated.datasets[0].backgroundColor =
            graphBrandingColors.objectivesByLeadership;
          return updated;
        });
      }
    );
  };

  const getAssignmentCount = (val = undefined) => {
    var pdata = "?type=organisation&organisation_id=" + orgId;
    DataService.getDirectData("/assignments/statistics" + pdata).then(
      (response) => {
        // const chartData =
        //   response?.statistics?.length &&
        //   response?.statistics.filter((item: any) =>
        //   ["Completed", "In progress", "Cancelled"].includes(item.label)
        //   );
        const itemsArray = [
          "in progress",
          "received",
          "shortlist",
          "completed",
          "chemistry",
          "cancelled",
        ];
        const chartData: any =
          response?.statistics?.length &&
          response?.statistics.filter((item: any, index: any) =>
            itemsArray.includes(item.label.toLowerCase())
          );
        const chartObj: any = {
          dataset: [],
          data: [],
        };
        if (chartData) {
          chartData.forEach((element: any) => {
            chartObj.dataset.push(element.label);
            chartObj.data.push(element.value);
          });
        }
        setAssignmentCountData({ ...chartObj });
      }
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickNewOpen = () => {
    setNewOpen(true);
  };
  const handleNewClose = () => {
    setNewOpen(false);
  };
  const afterUpdateGraph = (objArr: any, checkedArr: any) => {
    const filteredCurrentChartDataArr = objArr.filter(
      (option: any) => option.checked
    );
    setAssignmentStatusChartData((oldData: any) => {
      const prev: any = { ...oldData };
      prev.datasets[0].data = filteredCurrentChartDataArr.map(
        (option: any, i: any) => option.value
      );
      prev.labels = filteredCurrentChartDataArr.map(
        (option: any, i: any) => option.name
      );

      return prev;
    });
    setChecked(checkedArr);
    handleClose();
  };

  const NotFoundFallback = () => {
    return (
      <Box
        style={{
          width: "100%",
          height: "23.5rem",
          maxHeight: "23.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          component={"p"}
          style={{ fontWeight: 800, fontSize: "1.1rem" }}
        >
          Data not found
        </Typography>
      </Box>
    );
  };

  const renderBar = (data: any) => {
    const dataLength = data.datasets[0].data.length;
    const labelLength = data.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            id={orgId}
            data={data}
            // options={barOptions}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  };

  // const renderCompentencyBar = useCallback(() => {
  //   const dataLength = assignmentCompetency.datasets[0].data.length;
  //   const labelLength = assignmentCompetency.labels.length;
  //   return (
  //     <>
  //       {dataLength > 0 && labelLength > 0 ? (
  //         <Bar
  //           key={Math.random()}
  //           id={`renderCompentencyBar_${orgId}`}
  //           data={assignmentCompetency}
  //           options={chartConstants.horizontaloptions}
  //         />
  //       ) : (
  //         <NotFoundFallback />
  //       )}
  //     </>
  //   );
  // }, [assignmentCompetency.datasets[0].data.length]);

  const [evaluationTableData, setEvaluationTableData] = useState([]);
  // const getEvaluationRating = (organisationId:any,filter:any) => {
  //   var pdata =
  //     organisationId == null ? "" : "?organisation_id=" + organisationId;

  //   DataService.getDirectData(
  //     "dashboards/evaluation_dashboard" + pdata,
  //     {filter:filter?filter:undefined}
  //   ).then((response) => {
  //     console.log(response,"eval");
  //     setEvaluationTableData(response.data);
  //     // setChartLoader((prev) => ({ ...prev, evaluationTableData: false }));
  //   });
  // };
  const createCircle = (index: number) => {
    const backgroundColour = [
      "#07438f",
      "#078f47",
      "#a3a110",
      "#40bac6",
      "#086e99",
      "#636569",
    ];
    return (
      <svg height="22" width="22" style={{ paddingRight: "5px" }}>
        <circle
          cx="11"
          cy="11"
          r="6"
          stroke={backgroundColour[index % 6]}
          stroke-width="2"
          fill="none"
        />
      </svg>
    );
  };
  const afterUpdateNewGraph = (objArr: any, checkedArr: any) => {
    const filteredCurrentChartDataArr = objArr.filter(
      (option: any) => option.checked
    );
    const newAssignmentUtilizeCoach = { ...assignmentUtilizeCoach };
    newAssignmentUtilizeCoach.datasets[0].data =
      filteredCurrentChartDataArr.map((option: any, i: any) => option.value);
    newAssignmentUtilizeCoach.labels = filteredCurrentChartDataArr.map(
      (option: any, i: any) => option.name
    );
    setAssignmentUtilizeCoach(newAssignmentUtilizeCoach);
    setNewChecked(checkedArr);
    handleNewClose();
  };
  const [downloading, setDownloading] = useState(false);
  const [downloadingOption, setDownloadinOption] = useState("");
  const handlePdfDownload = () => {
    // pdfmarker
    setDownloading(true);
    setDownloadinOption("pdf");
    const settings = {
      margin: { left: 20, right: 20 },
      headerHeight: 25,
      columnGap: 10,
      rowGap: 5,
      width: 125,
      height: 75,
    };

    const pdf = new jsPDF({ orientation: "landscape", format: "a4" });
    pdf.setPage(1);
    drawHeader();
    drawFooter();

    const quadrantPlacement = {
      firstQuadrant: {
        offsetX: settings.margin.left,
        offsetY: settings.headerHeight,
        widthX: settings.width,
        widthY: settings.height,
      },
      secondQuadrant: {
        offsetX: settings.margin.left,
        offsetY: settings.headerHeight + settings.height + settings.rowGap,
        widthX: settings.width,
        widthY: settings.height,
      },
      thirdQuadrant: {
        offsetX: settings.margin.left + settings.width + settings.columnGap,
        offsetY: settings.headerHeight,
        widthX: settings.width,
        widthY: settings.height,
      },
      fourthQuadrant: {
        offsetX: settings.margin.left + settings.width + settings.columnGap,
        offsetY: settings.headerHeight + settings.height + settings.rowGap,
        widthX: settings.width,
        widthY: settings.height,
      },
    };

    const graphsDownloadsMetaData = [
      {
        className: "quick_statistics_graph",
        ...quadrantPlacement.firstQuadrant,
        ignoreElements: [
          "view_summary_quick_statistics",
          "assignments_heading_quick_statistics",
        ],
        newPage: false,
        page: 1,
      },
      {
        className: "status_graph",
        ...quadrantPlacement.secondQuadrant,
        ignoreElements: ["settings_icon_assignments_graph"],
        newPage: false,
        page: 1,
      },

      {
        className: "evaluation_ratings_graph",
        ...quadrantPlacement.thirdQuadrant,
        ignoreElements: [],
        newPage: false,
        page: 1,
      },
      {
        className: "sla_metrics_graph",
        ...quadrantPlacement.fourthQuadrant,
        ignoreElements: [],
        newPage: true,
        page: 1,
      },
      {
        className: "objectives_by_leadership_graph",
        ...quadrantPlacement.firstQuadrant,
        ignoreElements: [],
        newPage: false,
        page: 2,
      },
      {
        className: "most_utilised_coaches_graph",
        ...quadrantPlacement.secondQuadrant,
        ignoreElements: [
          "most_utilised_graph_select_option",
          "most_utilised_graph_settings_icon",
        ],
        newPage: false,
        page: 2,
      },
      {
        className: "average_duration_of_assignments_graph",
        ...quadrantPlacement.thirdQuadrant,
        ignoreElements: ["average_duration_graph_select_option"],
        newPage: false,
        page: 2,
      },
      {
        className: "assignments_by_graph",
        ...quadrantPlacement.fourthQuadrant,
        ignoreElements: [
          "select_option_assignment_by_graph",
          "settings_icon_assignment_by_graph",
        ],
        newPage: true,
        page: 2,
      },
      {
        className: "assignments_per_month_graph",
        ...quadrantPlacement.firstQuadrant,
        ignoreElements: [
          "assignments_per_month_select_option_1",
          "assignments_per_month_select_option_2",
        ],
        newPage: false,
        page: 3,
      },
    ];

    function drawHeader() {
      const acuityLogo = new Image();
      acuityLogo.src = logoImage;

      pdf.addImage(
        acuityLogo,
        "PNG",
        pdf.internal.pageSize.width - settings.margin.left - 70,
        7,
        70,
        16
      );

      const clientLogo = new Image();
      clientLogo.src = clientLogoDemo;
      const logoDimension = 16;
      pdf.addImage(
        clientLogo,
        "PNG",
        settings.margin.left,
        5,
        logoDimension,
        logoDimension
      );
    }

    function drawFooter() {
      // Footer
      let pageString = `${pdf.getCurrentPageInfo().pageNumber}`;
      pdf.setFontSize(10);

      pdf.setFont("helvetica");
      pdf.setTextColor(119, 119, 119);
      const pageSize = pdf.internal.pageSize;
      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();
      const creationDateString = `${moment().format(
        "MMMM Do YYYY, h:mm:ss a"
      )}`;
      pdf.textWithLink(
        "www.acuitycoaching.com",
        settings.margin.left,
        pageHeight - 10,
        {
          url: "www.acuitycoaching.com",
        }
      );
      pdf.text(
        pageString,
        pdf.internal.pageSize.width / 2 - 1,
        pageHeight - 10
      );
      pdf.text(
        creationDateString,
        pdf.internal.pageSize.width - settings.margin.right - 50,
        pageHeight - 10
      );
    }
    // const createNewPage = () => {
    //   pdf.addPage();
    //   drawHeader();
    //   drawFooter();
    // };
    const promiseChain: any = [];

    
    const totalPages = 3;
    const createPages = (totalPage: number) => {
      for (let i = 1; i <= totalPage; i++) {
        if (i !== 1) {
          pdf.addPage();
        }
        pdf.setPage(i);
        drawHeader();
        drawFooter();
      }
    };
    createPages(totalPages);
    graphsDownloadsMetaData.forEach((graph, ind) => {
      let input: any = window.document.getElementsByClassName(
        graph.className
      )[0];
      const ignoreElem = graph.ignoreElements?.map((el: any) => {
        return window.document.getElementsByClassName(el);
      });

      const promise = html2canvas(input, {
        ignoreElements: (event: any) => {
          let ignoreFlag = false;
          ignoreElem?.forEach((el) => {
            if (el[0].isEqualNode(event)) {
              ignoreFlag = true;
            }
          });
          return ignoreFlag;
        },
      }).then((canvas: any) => {
        return new Promise((resolve) => {
          const img = canvas.toDataURL("image/png");
          pdf.setPage(graph.page);
          pdf.addImage(
            img,
            "png",
            graph.offsetX,
            graph.offsetY,
            graph.widthX,
            graph.widthY
          );
          setTimeout(() => {
            resolve("");
          }, 5000);
        });
      });
      promiseChain.push(promise);
    });
    Promise.all([...promiseChain])
      .then(() => {
        pdf.save("chart.pdf");
      })
      .finally(() => {
        setDownloading(false);
        setDownloadinOption("");
      });
  };
  return (
    <>
      {pathname !== "/ManageInfo" && <HomeHeaderMenu />}
      <Box p={6} bgcolor="#B4B4B440" overflow={"hidden"}>
        <Box>
          <Grid container direction="row">
            <Grid item xs={8}>
              <Typography variant="h1" style={{ color: "#077f83" }}>
                <Box fontWeight="fontWeightBold">Dashboard</Box>
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
              style={{
                display: "flex",
                gap: "0.75rem",
                justifyContent: "flex-end",
              }}
            >
              <Button
                disableElevation
                style={{
                  backgroundColor: "#077f83",
                  color: "#fff",
                  textTransform: "none",
                  float: "right",
                }}
                onClick={handlePdfDownload}
              >
                {downloading && downloadingOption === "pdf" ? (
                  <CircularProgress
                    size={20}
                    style={{ color: "white", marginRight: "4px" }}
                  />
                ) : (
                  <SaveAlt style={{ marginRight: "4px" }} />
                )}
                Download pdf
              </Button>
              <Button
                disableElevation
                style={{
                  backgroundColor: "#077f83",
                  color: "#fff",
                  textTransform: "none",
                  float: "right",
                }}
              >
                {downloading && downloadingOption === "xlsx" ? (
                  <CircularProgress
                    size={20}
                    style={{ color: "white", marginRight: "4px" }}
                  />
                ) : (
                  <SaveAlt style={{ marginRight: "4px" }} />
                )}
                Download xlsx
              </Button>
            </Grid>
          </Grid>
        </Box>
        {/* <Box mt={3}>
          <Grid container direction="row" alignItems="flex-end">
            <Grid item xs={4}>
              <Typography variant="h2" style={{ color: "#EF7000" }}>
                <Box mb={1} fontWeight="fontWeightBold">
                  Service type
                </Box>
              </Typography>
              <CustomSelect
                id="serviceType"
                labelText="Select service type"
                displayEmpty
                variant="outlined"
                itemArr={serviceList}
                parentcall={onChangeItem}
                defaultValue={userData.serviceType}
              />
            </Grid>
          </Grid>
        </Box> */}
        <Box mt={3} className="allGraphs">
          <Grid container spacing={2}>
            {/* <Grid item xs={12}>
              <Grid container direction="row" alignItems="center" spacing={2}>
                
                
              </Grid>
            </Grid> */}
            <Grid item xs={6}>
              <Box
                bgcolor="#fff"
                padding={"15px"}
                className="quick_statistics_graph"
              >
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1">
                      <Box mb={1} fontWeight="fontWeightBold" color={"#EF7000"}>
                        Quick statistics
                      </Box>
                    </Typography>
                    <Typography variant="subtitle1">
                      <Box
                        mb={1}
                        className="assignments_heading_quick_statistics"
                      >
                        Assignments
                      </Box>
                    </Typography>
                  </Grid>
                  {assignmentCountData ? (
                    <Grid item xs={12} container spacing={2}>
                      <Grid xs={6}>
                        <Doughnut
                          data={{
                            labels: assignmentCountData?.dataset || [],
                            datasets: [
                              {
                                label: "Assignments",
                                data: assignmentCountData?.data || [],
                                backgroundColor: [
                                  "#07438f",
                                  "#078f47",
                                  "#a3a110",
                                  "#40bac6",
                                  "#086e99",
                                  "#636569",
                                ],
                                hoverOffset: 1,
                              },
                            ],
                            text: "100%",
                          }}
                        />
                      </Grid>
                      <Grid xs={6} style={{ alignSelf: "center" }}>
                        <List style={{ paddingLeft: "10px" }}>
                          {assignmentCountData?.dataset.map(
                            (item: any, index: number) => (
                              <ListItem>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                >
                                  <Typography
                                    variant="h2"
                                    component="span"
                                    style={{
                                      display: "inline-flex",
                                    }}
                                  >
                                    {createCircle(index)}
                                    {item}
                                  </Typography>
                                  <Typography variant="h2" component="span">
                                    {assignmentCountData?.data[index]}
                                  </Typography>
                                </div>
                              </ListItem>
                            )
                          )}
                        </List>
                        <Divider
                          style={{
                            paddingLeft: "10px",
                          }}
                        />
                        <Typography
                          variant="h2"
                          style={{ color: "#4A4A4A", marginTop: "10px  " }}
                        >
                          <Box
                            mb={3}
                            textAlign="right"
                            className="view_summary_quick_statistics"
                          >
                            <Link
                              href=""
                              onClick={() => history.push("/ManageInfo")}
                              style={{ color: "#981B1E" }}
                            >
                              View summary{" "}
                              <ArrowForwardIcon
                                style={{ marginLeft: 10, fontSize: 14 }}
                              />
                            </Link>
                          </Box>
                        </Typography>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid xs={12}>
                      <Typography
                        component={"p"}
                        style={{
                          fontWeight: 800,
                          fontSize: "1.1rem",
                          textAlign: "center",
                        }}
                      >
                        Data not found
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box bgcolor="#fff" className="status_graph" padding={"15px"}>
                <AssignmentStatusGraph
                  organisationId={{ id: orgId }}
                  plainView={true}
                  fullStats={true}
                />
              </Box>
            </Grid>
            {/* <Grid item xs={6} >
                  <Box bgcolor="#fff" padding={"15px"}>
                    <Grid container direction="row" spacing={4}>
                      <Grid item xs={8}>
                        <Typography variant="subtitle1">
                          <Box
                            mb={2}
                            fontWeight="fontWeightBold"
                            color={"#EF7000"}
                          >
                            Assignment status
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Grid item xs={12}>
                          <Box textAlign="right">
                            <Badge color="primary" onClick={handleClickOpen}>
                              <SettingsIcon style={{ cursor: "pointer" }} />
                            </Badge>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={4}>
                      <Grid item xs={12}>
                        {renderBar(assignmentStatusChartData)}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid> */}
            <Grid item xs={6}>
              <Box
                bgcolor="#fff"
                className="assignments_by_graph"
                padding={"15px"}
              >
                <AssignmentsByGraph
                  organisationId={{ id: orgId }}
                  plainView={true}
                  graphColor={graphBrandingColors.assignmentBy}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                bgcolor="#fff"
                className="sla_metrics_graph"
                padding={"15px"}
              >
                <SLAMetricsGraph
                  organisationId={{ id: orgId }}
                  plainView={true}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                bgcolor="#fff"
                padding={"15px"}
                className="average_duration_of_assignments_graph"
              >
                <Grid container direction="row">
                  <Grid item xs={8}>
                    <Typography variant="subtitle1">
                      <Box fontWeight="fontWeightBold" color={"#EF7000"}>
                        Average duration of assignments
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    className="average_duration_graph_select_option"
                  >
                    <CustomSelect
                      variant="outlined"
                      id="avgDurationPeriod"
                      labelText="Select Time Period"
                      parentcall={onChangeItem}
                      placeholder="Last 6 months"
                      itemArr={["Last 6 months", "Last 12 months"]}
                      defaultValue={userData.avgDurationPeriod}
                    />
                  </Grid>
                </Grid>
                {/* <Grid item xs={12}> */}
                {assignmentDurationData.datasets[0].data.length > 0 &&
                assignmentDurationData.labels.length > 0 ? (
                  <Line data={assignmentDurationData} options={barOptions} />
                ) : (
                  <NotFoundFallback />
                )}
                {/* </Grid> */}
              </Box>
            </Grid>
            <Grid item xs={6}>
              {/* <Grid container direction="row" spacing={4}>
                <Grid item xs={12}> */}
              <Box
                bgcolor="#fff"
                padding={"15px"}
                className="assignments_per_month_graph"
              >
                <Grid container direction="row">
                  <Grid item xs={6}>
                    <Typography variant="subtitle1">
                      <Box mb={2} fontWeight="fontWeightBold" color={"#EF7000"}>
                        Assignments per month over a period
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <CustomSelect
                      variant="outlined"
                      id="perMonthDatatimePeriod"
                      labelText="Select Time Period"
                      parentcall={onChangeItem}
                      placeholder="Last 6 months"
                      itemArr={["Last 6 months", "Last 12 months"]}
                      defaultValue={userData.perMonthDatatimePeriod.byTime}
                      style={{ width: "80%", alignSelf: "center" }}
                      className="assignments_per_month_select_option_1"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <CustomSelect
                      // className={classes.selectClients}
                      variant="outlined"
                      id="perMonthDatatimePeriod"
                      labelText="Select Service"
                      parentcall={onChangeItem}
                      placeholder="by service"
                      itemArr={["by service", "by service type"]}
                      defaultValue={userData.perMonthDatatimePeriod.byType}
                      dataIndex={1}
                      style={{ width: "80%", alignSelf: "center" }}
                      className="assignments_per_month_select_option_2"
                    />
                  </Grid>
                  {/* <Grid item xs={12}> */}
                  {assignmentPerMonthData.datasets[0].data.length > 0 &&
                  assignmentPerMonthData.labels.length > 0 ? (
                    <Bar data={assignmentPerMonthData} options={barOptions} />
                  ) : (
                    <NotFoundFallback />
                  )}
                  {/* </Grid> */}
                </Grid>
              </Box>
              {/* </Grid> */}
              {/* <Grid item xs={4}>
                  <Box mt={3} bgcolor="#fff" p={3}></Box>
                </Grid> */}
              {/* </Grid> */}
            </Grid>
            <Grid item xs={6}>
              {/* <Grid container direction="row" spacing={4}>
                <Grid item xs={8}>
                  <Box mt={3} bgcolor="#fff" p={3}>
                    <Grid container direction="row" spacing={4}>
                      <Grid item xs={8}>
                        <Typography variant="subtitle1">
                          <Box
                            mb={2}
                            fontWeight="fontWeightBold"
                            color={"#EF7000"}
                          >
                            Committed spend
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid item xs={4}></Grid>
                      <Grid item xs={12}>
                        {chartConstants.data.datasets[0].data.length > 0 &&
                        chartConstants.data.labels.length > 0 ? (
                          <Bar
                            data={chartConstants.data}
                            options={chartConstants.options}
                          />
                        ) : (
                          <NotFoundFallback />
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box mt={3} bgcolor="#fff" p={3}>
                    <Typography variant="subtitle1">
                      <Box mb={2} fontWeight="fontWeightBold" color={"#EF7000"}>
                        SLA metrics
                      </Box>
                    </Typography>
                    <GaugeChart
                      id="gauge-chart5"
                      nrOfLevels={100}
                      arcsLength={[0.3, 0.5, 0.2]}
                      colors={["#5BE12C", "#F5CD19", "#EA4228"]}
                      percent={slaMatrixPercentage / 100}
                      arcPadding={0.02}
                      textColor="#232323"
                    />
                  </Box>
                </Grid>
              </Grid> */}
              {/* <Grid item xs={12}> */}
              {
                <Box
                  bgcolor="#fff"
                  padding={"15px"}
                  className="most_utilised_coaches_graph"
                >
                  <Grid container direction="row">
                    <Grid item xs={6}>
                      <Typography variant="subtitle1">
                        <Box fontWeight="fontWeightBold" color={"#EF7000"}>
                          Most utilised coaches
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      className="most_utilised_graph_select_option"
                    >
                      {/* <CustomSelect
                        variant="outlined"
                        id="assignmentMostUtilizeCoach"
                        labelText="Select Time Period"
                        parentcall={onChangeItem}
                        placeholder="India"
                        itemArr={mostUtilizedCoach.map((el)=>el.value)}
                        // itemArr = {["india"]}
                        defaultValue={userData.assignmentMostUtilizeCoach}
                      /> */}
                      <CustomSelect
                        // className={classes.selectClients}
                        variant="outlined"
                        id="mostUtilizedLocation"
                        labelText="Select location"
                        parentcall={onChangeItem}
                        placeholder="Select location"
                        displayEmpty
                        itemArr={mostUtilizedLocationArr}
                        defaultValue={userData.mostUtilizedLocation}
                        dataIndex={0}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      className="most_utilised_graph_settings_icon"
                    >
                      <Box textAlign="center">
                        <SettingsIcon
                          style={{ cursor: "pointer" }}
                          onClick={handleClickNewOpen}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      {assignmentUtilizeCoach.datasets[0].data.length > 0 &&
                      assignmentUtilizeCoach?.labels?.length > 0 ? (
                        <Bar
                          data={assignmentUtilizeCoach}
                          options={{
                            ...assignmentUtilizeCoach,
                            indexAxis: "x",
                            scales: {
                              x: {
                                stacked: true,
                              },
                              y: {
                                // stacked: true,
                                // max: 10,
                                min: 0,
                                ticks: { stepSize: 1 },
                                grace: "50%",
                              },
                            },
                          }}
                        />
                      ) : (
                        <NotFoundFallback />
                      )}
                    </Grid>
                  </Grid>
                </Box>
              }
              {/* </Grid> */}
            </Grid>
            <Grid item xs={6}>
              <Box
                bgcolor="#fff"
                padding={"15px"}
                className="objectives_by_leadership_graph"
              >
                <Typography variant="subtitle1">
                  <Box mb={2} fontWeight="fontWeightBold" color={"#EF7000"}>
                    Objectives by leadership capability framework
                  </Box>
                </Typography>
                {assignmentCompetency.datasets[0].data.length > 0 &&
                assignmentCompetency.labels.length > 0 ? (
                  <Bar
                    data={assignmentCompetency}
                    options={chartConstants.horizontaloptions}
                  />
                ) : (
                  <NotFoundFallback />
                )}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                bgcolor="#fff"
                padding={"15px"}
                className="evaluation_ratings_graph"
              >
                <EvaluationRatingsGraph
                  organisationId={{ id: orgId }}
                  plainView={true}
                  graphColor={graphBrandingColors.evaluationRatings}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {open && (
        <DashboardChartService
          currentChartDataArr={currentChartDataArr}
          setCurrentChartDataArr={setCurrentChartDataArr}
          afterUpdateGraph={afterUpdateGraph}
          open={open}
          handleClose={handleClose}
          grpahChecked={checked}
        />
      )}
      {newOpen && (
        <DashboardChartService
          assignmentList={true}
          currentChartDataArr={currentNewChartDataArr}
          setCurrentChartDataArr={setCurrentNewChartDataArr}
          afterUpdateGraph={afterUpdateNewGraph}
          open={newOpen}
          handleClose={handleNewClose}
          grpahChecked={newChecked}
        />
      )}
    </>
  );
}

export default Dashboard;
